import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import {
  mediaTabletAndUp,
  PreloadableImage,
  UnstyledLinkLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

interface BASCampaignLogoProps {
  id: number;
  path: string;
  name: string;
  imagePath: string;
}

export const BASCampaignHeaderLogo: FC<BASCampaignLogoProps> = ({
  id,
  path,
  name,
  imagePath,
}) => {
  const {isActive} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_tommy_hilfiger',
  );

  return (
    <BASLogoWrapper
      to={path}
      data-testid="HeaderBASLogo"
      $largerWidth={isActive}
    >
      <StyledTrackPromotions
        data-testid="HeaderBASLogoTracked"
        promotion={{
          advertisement: {
            id,
            path,
            name,
          },
          source: TrackingPromotionCreative.BasLogoIntegration,
        }}
        streamPosition={1}
      >
        <StyledPreloadableImage
          src={imagePath}
          importance="high"
          loading="eager"
        />
      </StyledTrackPromotions>
    </BASLogoWrapper>
  );
};

const BASLogoWrapper = styled(UnstyledLinkLinaria)<{$largerWidth?: boolean}>`
  align-items: center;
  display: flex;
  padding: 2px;
  height: 100%;

  @media ${mediaTabletAndUp} {
    max-width: ${props => (props.$largerWidth ? '250px' : '150px')};
  }
`;

const StyledTrackPromotions = styled(TrackPromotions)`
  display: flex;
  height: 100%;
`;

const StyledPreloadableImage = styled(PreloadableImage)`
  height: 100%;
  object-fit: contain;
  object-position: 0 center;
`;
